// frontend/src/pages/PayrollItems/components/AccordionRow.tsx
// Collapsible section wrapper. Used 4 times on the Payroll Items page
// (Pay types, Deductions, Pay schedules, Work locations).

import React from "react";
import { ChevronRight } from "lucide-react";
import { BORDER_LIGHT, TEXT_SECONDARY, TEXT_INK } from "../styles";

interface AccordionRowProps {
  open: boolean;
  onToggle: () => void;
  /** Icon node shown before the title (e.g. <CircleDollarSign />). */
  icon: React.ReactNode;
  title: string;
  count: number;
  /** Status chip rendered on the right (e.g. <CHIP_OK /> or <CHIP_WARN />). */
  chip: React.ReactNode;
  /** Content to show when the row is expanded. */
  children: React.ReactNode;
}

export default function AccordionRow({
  open,
  onToggle,
  icon,
  title,
  count,
  chip,
  children,
}: AccordionRowProps): React.ReactElement {
  return (
    <div style={{ borderBottom: "0.5px solid " + BORDER_LIGHT }}>
      <div
        onClick={onToggle}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "18px 4px",
          cursor: "pointer",
        }}
      >
        <ChevronRight
          size={18}
          style={{
            color: TEXT_SECONDARY,
            transform: open ? "rotate(90deg)" : "rotate(0deg)",
            transition: "transform 0.15s",
          }}
        />
        {icon}
        <span style={{ fontSize: 17, fontWeight: 700, color: TEXT_INK }}>{title}</span>
        <span style={{ fontSize: 17, fontWeight: 600, color: TEXT_SECONDARY }}>
          ({count})
        </span>
        <span style={{ marginLeft: "auto" }}>{chip}</span>
      </div>
      {open && <div style={{ padding: "4px 4px 22px 38px" }}>{children}</div>}
    </div>
  );
}